import React, { useState, useEffect, useRef } from "react";
import { rugsharehomelink, cinematicimages } from "./../../constants";
import styled from "styled-components";
import ReactGA from 'react-ga';
import Api from "./../../api";


import {useEventListener} from "./../../hooks";


const eachframetime = 8;

const Wrapper = styled.div`
position: absolute;
width: calc(100% - 2rem);
height: calc(100% - 1.3rem);
margin: 0.65rem 1rem;
pointer-events: none;
`;
const TVFrame = styled.div`
  position: absolute;  
  overflow: hidden;
  left: 12%;
  border: none;
  width: 44.2%;
  height: 44.2%;
  top: 36.1%;
  left: 10.8%;
  transform: none;
  display:block;
  ${(props) => (props.show ? "visibility:visible;" : "visibility:hidden;z-index:-1;")}
`;
const ImgFrame = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const AnimateImg = styled.img`
  position: absolute;
  display: ${(props) => (props.show ? "block" : "none")};
  ${(props) =>
    props.animclass === "slide" ? "width: calc(100% + 50px);" : "width:100%;"}
  height: auto;
  opacity: 0;
  ${(props) =>
    props.activeindex === props.index || props.activeindex === props.index - 1
      ? "animation: "+eachframetime*2+"s animateimg" + props.animclass + ";"
      : ""}
  ${(props) =>
    props.activeindex === 0 && props.index === 0
      ? "animation: "+eachframetime*2+"s animateimg0;"
      : ""}
      ${(props) =>
        props.activeindex === cinematicimages.length - 1 && props.index === 0
        ? "animation: "+eachframetime*2+"s animateimg" + props.animclass + ";"
        : ""}
  @keyframes animateimg0 {
    0% {
      transform: scale(1.1);
      opacity: 1;
    }
    43% {
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: scale(1);
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes animateimgslide {
    0% {
      opacity: 0;
    }
    40% {
      opacity: 0;
    }
    45% {
      transform: translate(-50px, -30px);
    }
    50% {
      opacity: 1;
    }
    93% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translate(0px, 0px);
    }
  }
  @keyframes animateimgzoomin {
    0% {
      opacity: 0;
    }
    40% {
      opacity: 0;
    }
    45% {
      transform: scale(1.1);
    }
    50% {
      opacity: 1;
    }
    93% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  @keyframes animateimgzoomout {
    0% {
      opacity: 0;
    }
    40% {
      opacity: 0;
    }
    45% {
      transform: scale(1);
    }
    50% {
      opacity: 1;
    }
    93% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: scale(1.1);
    }
  }
`;
const InfoBubble = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
  background: ${(props) => props.color};  
  &.left {
  animation: ${eachframetime*2}s forwards leftbubble;

  }

  &.leftalt {
  animation: ${eachframetime*2}s forwards leftaltbubble;

  }

  @keyframes leftbubble {
    0% {
      opacity: 0;
      margin-bottom: -25px;
    }
    10% {
      opacity: 1;
      margin-bottom: -20px;
    }
    85% {
      opacity: 1;
      margin-bottom: -20px;
    }
    95% {
      opacity: 0;
      margin-bottom: -25px;
    }
    100% {
      opacity: 0;
      margin-bottom: -25px;
    }
  }

  @keyframes leftaltbubble {
    0% {
      opacity: 0;
      margin-bottom: -25px;
    }
    10% {
      opacity: 1;
      margin-bottom: -20px;
    }
    85% {
      opacity: 1;
      margin-bottom: -20px;
    }
    95% {
      opacity: 0;
      margin-bottom: -25px;
    }
    100% {
      opacity: 0;
      margin-bottom: -25px;
    }
  }


  & .infoContainer {
    position: absolute;
    padding-top: 6px;
    padding-top: 10%;
    left: 30px;
    width: calc(100% - 30px);
    bottom: 20px;
    height: calc(100% - 20px);
    box-sizing: border-box;
    color: white;
    font-family: sans-serif;
    font-size: 12px;
  }
  &.right .infoContainer {
    left: unset;
    right: 30px;
    text-align: right;
  }

  &.left .infoContainer > div {
    margin-left: 8px;
    padding-right: 8px;
  }
  &.leftalt .infoContainer > div {
    margin-left: 8px;
    padding-right: 8px;
  }

  &.right .infoContainer > div {
    margin-right: 8px;
    padding-left: 8px;
  }

  & .rugTitle {
    font-weight: 600;
    width: fit-content;
    border-bottom: 1px solid white;
    position: absolute;
    left: 0;
  }
  & .rugTitle{
    animation: ${eachframetime*2}s forwards topdownleft;
  }


  @keyframes topdownleft {
    0% {
      margin-top: -3px;
    }
    12% {
      margin-top: 0px;
    }
    85% {
      margin-top: 0px;
    }
    98% {
      margin-top: -3px;
    }
  }


  &.right .rugTitle {
    right: 0;
    left: unset;
  }
  & .minidisc {
    font-size: 6px;
  }
  & .scantext {
    margin-top: 16px;
    font-size: 8px;
    padding-top: 2px;
    line-height: 8px;
    margin-bottom: 6px;
  }
  & .scantext > p {
    margin: 0;
  }

  & .qrdiv {
    margin-left: 21px;
  }
  & .qrdiv > img {
    width: 48px;
    cursor: pointer;
    pointer-events: all;
  }
  & .linkdiv {
    font-size: 8px;
    cursor: pointer;
    pointer-events: all;

  }
`;

function MiniCinematic(props) {
  const { show } = props;
  const [startshow, setstartshow] = useState(false);
  const [infoClass, setinfoClass] = useState("left");
  const [infoSizeClass, setinfoSizeClass] = useState("large");
  const [activeindex, setactiveindex] = useState(0);
  const [loadNumber, setloadNumber] = useState(0);

  const frameRef = useRef(null);

  const animationClasses = [
    "zoomin",
    "slide",
    "zoomout",
    "zoomin",
    "slide",
    "zoomout",
  ];


  useEffect(() => {
    if (activeindex % 2 === 0) {
      infoClass === "leftalt" ? setinfoClass("left") : setinfoClass("leftalt");
    }
  }, [activeindex]);


  useEffect(() => {

    if(show){
      calculateinfosize();
    }
    
  }, [show])

  const calculateinfosize = () =>{
    console.log("info size");
    setTimeout(() => {
      calc();
    }, 100);

    function calc(){
      if(frameRef && frameRef.current){
        console.log(frameRef);
        if(frameRef.current.clientHeight > 400){console.log(frameRef.current.clientHeight, " xlarge");setinfoSizeClass("xlarge")}
        else if(frameRef.current.clientHeight > 250){console.log(frameRef.current.clientHeight, " large");setinfoSizeClass("large")}
        else if(frameRef.current.clientHeight > 150){console.log(frameRef.current.clientHeight, " medium");setinfoSizeClass("medium")}
        else{console.log(frameRef.current.clientHeight, " small");setinfoSizeClass("small")}
      }
    }

  }

  const handleqrclick = (link,action) => {
    window.open(link);
    ReactGA.event({
      category: 'Links',
      action: 'Click in cinematic',
      value: link,
      label:link
    });
    Api.logData(action,"Cinematic");
  };
  const handlecinematicimgload = () => {
    if (loadNumber + 1 === cinematicimages.length) {
      setstartshow(true);
      let animinterval = setInterval(() => {
        setactiveindex((activeindex) =>
          activeindex === cinematicimages.length - 1 ? 0 : activeindex + 1
        );
      }, eachframetime *1000);
    }
    setloadNumber((loadNumber) => loadNumber + 1);
  };
  useEventListener("resize", calculateinfosize);




  return (
    <React.Fragment>
      <Wrapper>
      <TVFrame show={show} ref={frameRef} >

        <ImgFrame>
          {cinematicimages.map((element, index) => {
            return (
              <AnimateImg
              key={index}
                src={element.imgsrc}
                onLoad={() => handlecinematicimgload()}
                index={index}
                activeindex={activeindex}
                animclass={animationClasses[index]}
                show={startshow}
              ></AnimateImg>
            );
          })}
        </ImgFrame>

        <InfoBubble
          show={startshow}
          className={infoClass+" "+infoSizeClass+ " infobubble"}
          color={cinematicimages[activeindex].color}
        >
          <div className={"infoContainer"}>
            <div className={"rugTitle"}>
              {cinematicimages[activeindex].name}
            </div>
            {/* <div className={"minidisc"}>Available for Custom Orders</div> */}
            <div className={"scantext"}>
              <p>Scan the QR code to </p>
              <p>view this design</p>
              {/* <p>Scan the QR code with</p>
            <p>your phone to customize</p>
            <p>and view this design in</p>
            <p>your room</p> */}
            </div>
            <div
              className={"qrdiv"}
              onClick={() =>
                handleqrclick(
                  rugsharehomelink + cinematicimages[activeindex].link,
                  cinematicimages[activeindex].action
                )
              }
            >
              <img src={cinematicimages[activeindex].qr}></img>
            </div>
            <div
              className={"linkdiv"}
              onClick={() =>
                handleqrclick(
                  rugsharehomelink + cinematicimages[activeindex].link,
                  cinematicimages[activeindex].action
                )
              }
            >
              {rugsharehomelink + cinematicimages[activeindex].link}
            </div>
          </div>
        </InfoBubble>
      </TVFrame>
      </Wrapper>
    </React.Fragment>
  );
}

export default MiniCinematic;
